'use client';

import { useState } from 'react';

import { createTabsComponent } from '@flipster/react/design-system';
import { css } from '@flipster/styled-system/css';

import { LuckyDrawItemFragment, LuckyDrawPrizeItemFragment } from '../../../query.generated';
import { slugToNameMapper } from '../constants';
import { Rewards } from './rewards';
import { SpinMachine } from './spin-machine';

interface Props {
  slugs: string[];
  luckyDrawData: LuckyDrawItemFragment[];
}

export const Draws = ({ slugs, luckyDrawData }: Props) => {
  const Tabs = createTabsComponent<(typeof slugs)[number]>();

  const [selectedTab, setSelectedTab] = useState<(typeof slugs)[number]>(slugs[0]);

  return (
    <div className={css({ textAlign: 'center', pb: { base: 64, tablet: 80 } })}>
      <h2
        className={css({
          textStyle: 'Display/XL',
          color: 'content.default.level-4',
        })}
      >
        {luckyDrawData[0]?.title}
      </h2>
      <p
        className={css({
          textStyle: 'Title/S',
          color: 'content.default.level-3',
          pt: { base: 12, tablet: 16 },
          pb: { base: 24, tablet: 40 },
        })}
      >
        {luckyDrawData[0]?.description}
      </p>
      <Tabs type='fixed' value={selectedTab} border onChange={setSelectedTab}>
        {slugs.map((slug) => (
          <Tabs.Tab key={slug} value={slug} label={slugToNameMapper[slug].singular} />
        ))}
      </Tabs>
      {slugs.map((slug) => (
        <SpinMachine
          key={slug}
          slug={slug}
          isShow={selectedTab === slug}
          prizes={
            luckyDrawData
              .find((d) => d?.slug === slug)
              ?.prizesCollection?.items.filter(Boolean) as LuckyDrawPrizeItemFragment[]
          }
        />
      ))}
      <Rewards luckyDrawData={luckyDrawData} />
    </div>
  );
};
